import { checkAuthentication } from './middleware';

export const besrRoutes = [
    {
        path: '/besr/training',
        name: 'TrainingList',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/besr/TrainingList'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/besr/score',
        name: 'TrainingScore',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/besr/TrainingScore'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/besr/training/:id',
        name: 'TrainingSpace',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/besr/TrainingSpace'),
        props: true,
        beforeEnter: checkAuthentication
    }
]